import { MaterialInput } from "app/components"
import { Container } from "app/containers/Container"
import { LoggedOutAppNavRoutes } from "app/containers/RetirementApp/routes"
import { checkPasswordStrength } from "app/utils"
import { FormParser } from "app/utils/form/parser"
import { getBrandInfo } from "config"
import * as React from "react"
import { Alert, Button, Col, FormGroup, Modal, Row } from "react-bootstrap"
import { RecoverPasswordModal } from "../../components/RecoverPasswordModal"

interface IUserLoginState {
    username: string
    token: string
    showLoginModal: boolean
    isLoggingIn: boolean
    loginError: boolean
    showRegisterModal: boolean
    registrationError: boolean
    registrationErrorMessage: string
    isRegistering: boolean
    showPasswordRecoveryModal: boolean
    errorMessage: string
}

class UserLogin extends Container<{}, IUserLoginState> {
    state = {
        username: "",
        token: "",
        showLoginModal: false,
        isLoggingIn: false,
        loginError: false,
        showRegisterModal: false,
        registrationError: false,
        registrationErrorMessage: "",
        isRegistering: false,
        showPasswordRecoveryModal: false,
        errorMessage: "Username and/or password are incorrect.",
    }

    registrationInputs = this.getCustomerRegistationInputsConfig()
    brandInfo = this.getCustomerBrandInfo()

    componentWillMount() {
        this.Actions.Nav.updateNavRoutes(LoggedOutAppNavRoutes)

        this.onAppStateUpdate((appState) => {
            const userOp = appState.User.get("op")
            const loginError = userOp.error.ErrorCode !== 0
            const isLoggingIn = userOp.isBusy

            const accountsOp = appState.Accounts.get("op")
            const registrationError = accountsOp.error.ErrorCode !== 0
            const registrationErrorMessage = accountsOp.error.getErrorMessage()
            console.log(`accounts op message: ${registrationErrorMessage}`)
            const isRegistering = accountsOp.isBusy

            this.setState({
                isLoggingIn,
                loginError,
                isRegistering,
                registrationError,
                registrationErrorMessage,
            })
        })
    }

    login(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault()

        const { username, token } = this.state
        this.Actions.App.login(username, token)
    }

    resetPassword() {
        const showPasswordRecoveryModal = true
        const showLoginModal = false
        this.setState({ showPasswordRecoveryModal, showLoginModal })
    }

    onResetPasswordComplete(username: string, password: string) {
        const showPasswordRecoveryModal = false
        this.setState({ showPasswordRecoveryModal })
        this.Actions.App.login(username, password)
    }

    setUsername(e: React.ChangeEvent<HTMLInputElement>) {
        const username = e.currentTarget.value
        const loginError = false

        this.setState({ username, loginError })
    }

    setToken(e: React.ChangeEvent<HTMLInputElement>) {
        const token = e.currentTarget.value
        const loginError = false

        this.setState({ token, loginError })
    }

    register(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault()

        const args = FormParser.parseInputsWithPaths<{
            username: string
            password: string
        }>(e.currentTarget)

        const ruleErrors = checkPasswordStrength(args.password)
        if (ruleErrors) {
            const loginError = true
            const registrationError = true
            const registrationErrorMessage = ruleErrors
            this.setState({
                loginError,
                registrationError,
                registrationErrorMessage,
            })
        } else {
            this.Actions.App.register(args.username, args.password, args)
        }
    }

    renderContactEmail() {
        if (this.brandInfo.contactEmail) {
            const contactEmail = "mailto:" + this.brandInfo.contactEmail
            return (
                <span>
                    {" "}
                    or email <a href={contactEmail}>here</a>
                </span>
            )
        }
    }

    render() {
        const contactLanguage =
            this.brandInfo.contactLanguage ||
            "Questions? Please contact us via phone: "
        const contactPhone =
            "telno:" + this.brandInfo.contactPhone.replace(/\D/g, "")
        const contactEmail = "mailto:" + this.brandInfo.contactEmail
        const { errorMessage } = this.state
        return (
            <section>
                <header className="top-nav navbar-fixed-top">
                    <section className="navbar navbar-inverse">
                        <div className="container-fluid">
                            <div className="navbar-brand">
                                <a
                                    href="javascript:void(0)"
                                    onClick={() => this.scrollTo("top")}
                                >
                                    <img
                                        alt="Brand"
                                        src={this.brandInfo.imgUrl}
                                        className="img-fluid"
                                        style={{
                                            verticalAlign: "text-bottom",
                                            display: "inline-block",
                                            marginRight: 15,
                                        }}
                                    />
                                    <span>{this.brandInfo.brandName}</span>
                                </a>
                            </div>
                            {!getBrandInfo().suppressLandingPageTopInfo && (
                                <ul className="nav navbar-nav navbar-right">
                                    <li>
                                        <a
                                            href="javascript:void(0)"
                                            onClick={() =>
                                                this.scrollTo("about")
                                            }
                                        >
                                            {contactLanguage}
                                            <a href={contactPhone}>
                                                {this.brandInfo.contactPhone}
                                            </a>
                                            {this.renderContactEmail()}
                                        </a>
                                    </li>
                                    <li>
                                        <Button
                                            bsStyle="primary"
                                            className="navbar-btn"
                                            onClick={() =>
                                                this.setState({
                                                    showLoginModal: true,
                                                })
                                            }
                                        >
                                            Login
                                        </Button>
                                    </li>
                                </ul>
                            )}
                        </div>
                    </section>
                </header>

                <section className="login-container" id="top">
                    <Row>
                        <Col mdOffset={2} md={8}>
                            <h1 className="title">
                                {getBrandInfo().landingPageGreeting}
                            </h1>
                            <p className="lead">
                                Get a reasonable projection of the financial
                                future for you and your loved ones. It may take
                                a few minutes, but it will be worth it in the
                                long run!
                            </p>
                            <p>
                                <Button
                                    bsStyle="primary"
                                    onClick={() =>
                                        this.setState({ showLoginModal: true })
                                    }
                                >
                                    Login
                                </Button>
                                Or
                                <Button
                                    bsStyle="primary"
                                    onClick={() =>
                                        this.setState({
                                            showRegisterModal: true,
                                        })
                                    }
                                >
                                    Set up account
                                </Button>
                                if you wish to create an account.
                            </p>
                        </Col>
                    </Row>
                    <Row>
                        <p id="passwordReset">
                            Effective November 2022, new passwords will be
                            required to enhance security
                        </p>
                    </Row>
                </section>

                <RecoverPasswordModal
                    show={this.state.showPasswordRecoveryModal}
                    onHide={() =>
                        this.setState({ showPasswordRecoveryModal: false })
                    }
                    onPasswordRecoveryComplete={(u: string, p: string) =>
                        this.onResetPasswordComplete(u, p)
                    }
                />

                {/* Login Modal */}
                <Modal
                    show={this.state.showLoginModal}
                    onHide={() => this.setState({ showLoginModal: false })}
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Login &amp; Get Started</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <form name="loginForm" onSubmit={(e) => this.login(e)}>
                            <FormGroup>
                                <MaterialInput
                                    placeholder="Username"
                                    required
                                    onChange={(e) => this.setUsername(e)}
                                    value={this.state.username}
                                />
                            </FormGroup>
                            <FormGroup>
                                <MaterialInput
                                    placeholder="Password"
                                    required
                                    onChange={(e) => this.setToken(e)}
                                    value={this.state.token}
                                    type="password"
                                />
                            </FormGroup>
                            <br />
                            <FormGroup>
                                <Button
                                    type="submit"
                                    bsStyle="primary"
                                    bsSize="lg"
                                    disabled={this.state.isLoggingIn}
                                >
                                    {this.state.isLoggingIn
                                        ? "Logging In..."
                                        : "Login"}
                                </Button>
                            </FormGroup>
                            Forgot your username or password? Click{" "}
                            <a onClick={() => this.resetPassword()}>here</a>
                            {this.state.loginError ? (
                                <FormGroup>
                                    <Alert
                                        bsStyle="danger"
                                        className="animated fadeIn"
                                    >
                                        <strong>
                                            <i className="fa fa-fw fa-exclamation-circle" />
                                            <span>Uh oh!</span>
                                        </strong>
                                        <span>
                                            &nbsp;{errorMessage} Please try
                                            again or contact the support team.
                                        </span>
                                    </Alert>
                                </FormGroup>
                            ) : null}
                        </form>
                    </Modal.Body>
                </Modal>

                {/* Register Modal */}
                <Modal
                    show={this.state.showRegisterModal}
                    onHide={() => this.setState({ showRegisterModal: false })}
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Setup an Account</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <form
                            name="loginForm"
                            onSubmit={(e) => this.register(e)}
                        >
                            <Row>
                                {this.registrationInputs.map(
                                    (registrationInput) => (
                                        <Col
                                            md={6}
                                            key={registrationInput.name}
                                        >
                                            <FormGroup>
                                                <MaterialInput
                                                    name={
                                                        registrationInput.name
                                                    }
                                                    placeholder={
                                                        registrationInput.placeholder
                                                    }
                                                    type={
                                                        registrationInput.type
                                                    }
                                                    required
                                                />
                                            </FormGroup>
                                        </Col>
                                    )
                                )}
                            </Row>
                            <br />
                            <FormGroup>
                                <Button
                                    type="submit"
                                    bsStyle="primary"
                                    bsSize="lg"
                                    disabled={this.state.isRegistering}
                                >
                                    {this.state.isRegistering
                                        ? "Submitting..."
                                        : "Submit"}
                                </Button>
                            </FormGroup>

                            {this.state.registrationError ? (
                                <FormGroup>
                                    <Alert
                                        bsStyle="danger"
                                        className="animated fadeIn"
                                    >
                                        <strong>
                                            <i className="fa fa-fw fa-exclamation-circle" />
                                            <span>Uh oh!&nbsp;</span>
                                        </strong>
                                        <span
                                            dangerouslySetInnerHTML={{
                                                __html: this.state
                                                    .registrationErrorMessage,
                                            }}
                                        ></span>
                                    </Alert>
                                </FormGroup>
                            ) : null}
                        </form>
                    </Modal.Body>
                </Modal>
            </section>
        )
    }
}

export { UserLogin }



// WEBPACK FOOTER //
// ./src/app/containers/UserLogin/index.tsx